import { message } from "antd";
import { Form, Formik } from "formik";
import React from "react";
import { ButtonText } from "../../../model/views/Button.props";
import { EBTextInput } from "../eb-ui-components";

interface URLInputFormProps {
  submitCallback: (url: string) => Promise<void>;
  submitButtonText?: ButtonText;
  initialValue: string;
}

export function URLInputForm(mainProps: URLInputFormProps) {
  return (
    <Formik
      initialValues={{ url: mainProps.initialValue }}
      onSubmit={(values, actions) => {
        actions.setSubmitting(true);
        mainProps
          .submitCallback(values.url)
          .then(() => {
            actions.setSubmitting(false);
          })
          .catch((err) => {
            message.error(
              "Error occurred! Make sure all required fields are filled."
            );
            actions.setSubmitting(false);
          });
      }}
    >
      {(formProps) => (
        <Form>
          <EBTextInput label="" name="url" helpText="" required />
          <button
            className="btn btn-sm btn-primary mr-2"
            type="submit"
            disabled={formProps.isSubmitting}
          >
            {mainProps.submitButtonText ? (
              <>
                {formProps.isSubmitting
                  ? mainProps.submitButtonText.submitting
                  : mainProps.submitButtonText.normal}
              </>
            ) : (
              <>{formProps.isSubmitting ? "Saving... Please wait." : "Save"}</>
            )}
          </button>
        </Form>
      )}
    </Formik>
  );
}
